window.panelSoluzioneClosed = false;

function checkPanelSoluzione() {
    var panelSoluzione = document.getElementById('panelSoluzione');
    var packageSection = document.getElementById('package');
    var mdBreakpoint = window.matchMedia('(max-width: 991.98px)');
    var footer = document.querySelector('footer');

    if (!panelSoluzione) return;

    // Nascondi il pannello se il footer entra nella viewport
    if (footer) {
        var footerRect = footer.getBoundingClientRect();
        // Se il top del footer è visibile nella viewport
        if (footerRect.top < window.innerHeight) {
            panelSoluzione.classList.add('hidden');
        } else {
            panelSoluzione.classList.remove('hidden');
        }
    }

    panelSoluzione.classList.add('paneSolFixedBottom');
    //if (mdBreakpoint.matches) {
    //    // Mobile: sempre fixed bottom
    //    panelSoluzione.classList.add('paneSolFixedBottom');
    //} else {
    //    // Desktop: fixed bottom solo se il top di #package esce dalla viewport superiore
    //    if (packageSection) {
    //        var packageRect = packageSection.getBoundingClientRect();
    //        if (packageRect.top < 0) {
    //            panelSoluzione.classList.add('paneSolFixedBottom');
    //        } else {
    //            panelSoluzione.classList.remove('paneSolFixedBottom');
    //        }
    //    } else {
    //        panelSoluzione.classList.remove('paneSolFixedBottom');
    //    }
    //}
}

checkPanelSoluzione();
window.addEventListener('resize', checkPanelSoluzione);
window.addEventListener('scroll', checkPanelSoluzione);


// EVENT DELEGATION per toggleFixedBox
document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.toggleFixedBox');
    if (toggle) {
        // Trova il contenitore principale
        var panelWrapper = toggle.closest('#panelSoluzione');
        // Trova il vero pannello da aprire/chiudere
        var panel = toggle.closest('.panelSoluzione');
        // Applica solo se il wrapper ha la classe paneSolFixedBottom
        if (panelWrapper && panelWrapper.classList.contains('paneSolFixedBottom') && panel) {
            panel.classList.toggle('fixedBoxOpened');
        }
    }
});

// PULSANTE CHIUSURA PANNELLO
//document.addEventListener('DOMContentLoaded', function () {
//    document.querySelectorAll('.closePanel').forEach(function (btn) {
//        btn.addEventListener('click', function (e) {
//            e.preventDefault();
//            var pane = document.querySelector('.paneSolMob');
//            if (pane) {
//                pane.classList.add('hidden');
//                window.panelSoluzioneClosed = true; // Segna come chiuso
//            }
//        });
//    });
//});


